import {
  faPenToSquare,
  faTrash,
} from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  ToasterContent,
} from '@repo/videa-components/src/index';
import { Button } from '@repo/videa-components/src/ui/button';
import { useSetAtom } from 'jotai';
import { toast } from 'sonner';

import {
  type TPracticeGroup,
  useDeletePracticeGroup,
} from '../../../react-query/insights/usePracticeGroups';

import { isOnUpdatePageAtom, selectedPracticeGroupAtom } from './atoms';

export const PracticeGroupActions = ({ group }: { group: TPracticeGroup }) => {
  const setSelectedPracticeGroup = useSetAtom(selectedPracticeGroupAtom);
  const setIsOnUpdatePage = useSetAtom(isOnUpdatePageAtom);

  const handleSuccess = () => {
    toast(
      <ToasterContent
        toast={toast}
        title="DSO Region deleted!"
        description="Your region has been removed."
        buttonVariant="secondary"
      />,
    );
  };

  const { mutate: deletePracticeGroup } = useDeletePracticeGroup(handleSuccess);

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        dataTestId={`practice-group-edit-button-${group.name}`}
        onClick={() => {
          setSelectedPracticeGroup(group.id);
          setIsOnUpdatePage(true);
        }}
      >
        <FontAwesomeIcon icon={faPenToSquare} />
      </Button>
      <AlertDialog>
        <AlertDialogTrigger>
          <Button
            data-testid={`delete-practice-group-${group.name}`}
            variant="ghost"
            size="sm"
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Deleting a Region</AlertDialogTitle>
          </AlertDialogHeader>
          <AlertDialogDescription>
            Deleting this region is permanent and removes it from the system.
            Since it&apos;s available across the DSO, consider deactivating it
            to retain the group.
          </AlertDialogDescription>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                deletePracticeGroup({ practiceGroupId: group.id });
              }}
            >
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
